import { SHOW_MODAL, CLOSE_MODAL } from '../reducers/modal';
import { IMedia } from '../interfaces';
import { LOAD_LIST, CLEAR_LIST } from '../reducers/playlist';
import Axios, {AxiosResponse} from 'axios';
import config from '../config';

export function loadListObject(list: IMedia[]) {
    return {
        list,
        type: LOAD_LIST
    };
}

export function loadList(list?: any) {
    return (dispatch: any) => {
        if (list && list.length > 0)
            return new Promise<void>((ok, err) => {
                dispatch(loadListObject(list));
                ok();
            });

        return Axios.get(`${config.host}/track/playlist`).then((response: AxiosResponse) => {
            if (response && response.data)
                dispatch(loadListObject(response.data));
        }).catch ((err) => {
            console.log (err);
        });
    }
}


function clearListObject() {
    return {
        type: CLEAR_LIST
    };
}

export function clearList() {
    return (dispatch: any) => {
        dispatch(clearListObject());
    }
}